var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, forwardRef } from 'react';
import { Button } from '@vp/swan';
import { useUploadFiles } from '../Hooks';
import { useUploadConfiguration } from '../UploadConfigurationProvider';
/**
 * Button to facilitate uploads. Processing in done by a passed in callback.
 */
export const UploadsButton = forwardRef((props, ref) => {
    const uploadFiles = useUploadFiles();
    const { supportedFileTypes: { acceptedTypesAsString }, } = useUploadConfiguration();
    const { multiple = false, children, onClick } = props, rest = __rest(props, ["multiple", "children", "onClick"]);
    const inputRef = useRef(null);
    const onChange = (e) => {
        var _a;
        const selectedFiles = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.files;
        if (selectedFiles) {
            uploadFiles(selectedFiles);
            // No change will occur if the same file is selected again w/o clearing the value
            if (inputRef.current) {
                inputRef.current.value = '';
            }
        }
    };
    const onTextClick = (event) => {
        if (inputRef && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
            inputRef.current.click();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { ref: inputRef, accept: acceptedTypesAsString, type: "file", multiple: multiple, style: { display: 'none' }, onChange: onChange }),
        React.createElement(Button, Object.assign({ onClick: onTextClick }, rest, { ref: ref }), children)));
});
UploadsButton.displayName = 'UploadsButton';
//# sourceMappingURL=UploadsButton.js.map